import { render, staticRenderFns } from "./package-edit-tab.vue?vue&type=template&id=9fb010a6&scoped=true"
import script from "./package-edit-tab.vue?vue&type=script&lang=js"
export * from "./package-edit-tab.vue?vue&type=script&lang=js"
import style0 from "./package-edit-tab.vue?vue&type=style&index=0&id=9fb010a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fb010a6",
  null
  
)

export default component.exports